module.exports = __webpack_public_path__ + "static/media/rw.ef3cbcbc.svg";